class EventsNormalizer {
	constructor(rawResults) {
		this.data = rawResults.data;
	}

	normalizedData() {
		try {
			if (!this.data.search) {
				throw new Error('[ERROR] API issue, check search api results back!!!');
			}
		} catch (e) {
			return { error: e };
		}

		let rawResults = this.data.search;
		let searchResults = {
			totalResults: rawResults.count,
			offset: rawResults.offset,
			resultCards: [],
		};
		if (searchResults.totalResults === 0) {
			return searchResults;
		}
		searchResults.resultCards = rawResults.hits.map((rawResult) => {
			let card = {};
			let result = rawResult.doc.metaFields;
			card.eventType = result.EventType || '';
			card.eventName = result.EventName || '';
			card.eventVenue = result.EventVenue || '';
			card.eventStartDate = result.EventStartDate || '';
			card.eventEndDate = result.EventEndDate || '';
			card.link = result.EventWebSite || '';
			card.city = result.EventCity || '';
			card.state = result.EventState || '';
			card.country = result.EventCountry || '';
			card.engagementType = result.EngagementType || '';
			card.eventStartTime = result.EventSchedule.length ? result.EventSchedule[0].EventBeginTime : '';
			card.eventEndTime = result.EventSchedule.length ? result.EventSchedule[0].EventEndTime : '';
			return card;
		});
		return searchResults;
	}
}

export default EventsNormalizer;
